import dayjs from 'dayjs';

export const fmtCurrency = (v) => {
  if (v == null) return '₹0.00';
  return '₹' + Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (d) => d ? dayjs(d).format('DD MMM YYYY') : '-';
export const fmtDateInput = (d) => d ? dayjs(d).format('YYYY-MM-DD') : null;

export const statusColor = (s) => {
  const m = { PENDING: 'warning', SETTLED: 'success', PARTIAL: 'processing', CLOSED: 'success', ACTIVE: 'processing', GENERATED: 'success', ADVANCE: 'default' };
  return m[s] || 'default';
};
